import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddressBookListQueryVariables = Types.Exact<{
  target: Types.Scalars['String']['input'];
  filterValue?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AddressBookListQuery = { __typename?: 'Query', addressBook: { __typename?: 'AddressBookListResult', entries?: Array<{ __typename?: 'AddressBookEntry', cn: string, sn: string, givenName?: string | null, telephoneNumber: Array<string>, mail?: string | null, departmentNumber?: string | null, businessCategory?: string | null, description?: string | null, o?: string | null, homePhone?: string | null, mobile?: string | null, uid?: string | null }> | null } };

export type AddAddressBookEntryMutationVariables = Types.Exact<{
  target: Types.Scalars['String']['input'];
  entry: Types.AddressBookEntryData;
}>;


export type AddAddressBookEntryMutation = { __typename?: 'Mutation', addAddressBookEntry: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', type: string, location: Array<string>, context?: string | null }> | null } };

export type UpdateAddressBookEntryMutationVariables = Types.Exact<{
  target: Types.Scalars['String']['input'];
  cn: Types.Scalars['String']['input'];
  entry: Types.AddressBookEntryData;
}>;


export type UpdateAddressBookEntryMutation = { __typename?: 'Mutation', updateAddressBookEntry: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', type: string, location: Array<string>, context?: string | null }> | null } };

export type DeleteAddressBookEntryMutationVariables = Types.Exact<{
  target: Types.Scalars['String']['input'];
  cn: Types.Scalars['String']['input'];
}>;


export type DeleteAddressBookEntryMutation = { __typename?: 'Mutation', deleteAddressBookEntry: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } };

export type PersonalTargetQueryVariables = Types.Exact<{
  extensionId: Types.Scalars['Int']['input'];
}>;


export type PersonalTargetQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', number?: { __typename?: 'Number', shortNumber?: string | null, domain: { __typename?: 'Domain', name: string } } | null } | null> } | null };

export type SynchronizeAddressBookMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type SynchronizeAddressBookMutation = { __typename?: 'Mutation', synchronizeDomainAddressBook: { __typename?: 'SynchronizeDomainAddressBookResult', createdEntries?: number | null, updatedEntries?: number | null, deletedEntries?: number | null, failedEntries?: number | null } };


export const AddressBookListDocument = gql`
    query AddressBookList($target: String!, $filterValue: String) {
  addressBook(target: $target, filterValue: $filterValue) {
    entries {
      cn
      sn
      givenName
      telephoneNumber
      mail
      departmentNumber
      businessCategory
      description
      o
      homePhone
      mobile
      uid
    }
  }
}
    `;

/**
 * __useAddressBookListQuery__
 *
 * To run a query within a React component, call `useAddressBookListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressBookListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressBookListQuery({
 *   variables: {
 *      target: // value for 'target'
 *      filterValue: // value for 'filterValue'
 *   },
 * });
 */
export function useAddressBookListQuery(baseOptions: Apollo.QueryHookOptions<AddressBookListQuery, AddressBookListQueryVariables> & ({ variables: AddressBookListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressBookListQuery, AddressBookListQueryVariables>(AddressBookListDocument, options);
      }
export function useAddressBookListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressBookListQuery, AddressBookListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressBookListQuery, AddressBookListQueryVariables>(AddressBookListDocument, options);
        }
export function useAddressBookListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddressBookListQuery, AddressBookListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressBookListQuery, AddressBookListQueryVariables>(AddressBookListDocument, options);
        }
export type AddressBookListQueryHookResult = ReturnType<typeof useAddressBookListQuery>;
export type AddressBookListLazyQueryHookResult = ReturnType<typeof useAddressBookListLazyQuery>;
export type AddressBookListSuspenseQueryHookResult = ReturnType<typeof useAddressBookListSuspenseQuery>;
export type AddressBookListQueryResult = Apollo.QueryResult<AddressBookListQuery, AddressBookListQueryVariables>;
export const AddAddressBookEntryDocument = gql`
    mutation AddAddressBookEntry($target: String!, $entry: AddressBookEntryData!) {
  addAddressBookEntry(target: $target, entry: $entry) {
    errors {
      type
      location
      context
    }
  }
}
    `;
export type AddAddressBookEntryMutationFn = Apollo.MutationFunction<AddAddressBookEntryMutation, AddAddressBookEntryMutationVariables>;

/**
 * __useAddAddressBookEntryMutation__
 *
 * To run a mutation, you first call `useAddAddressBookEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAddressBookEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAddressBookEntryMutation, { data, loading, error }] = useAddAddressBookEntryMutation({
 *   variables: {
 *      target: // value for 'target'
 *      entry: // value for 'entry'
 *   },
 * });
 */
export function useAddAddressBookEntryMutation(baseOptions?: Apollo.MutationHookOptions<AddAddressBookEntryMutation, AddAddressBookEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAddressBookEntryMutation, AddAddressBookEntryMutationVariables>(AddAddressBookEntryDocument, options);
      }
export type AddAddressBookEntryMutationHookResult = ReturnType<typeof useAddAddressBookEntryMutation>;
export type AddAddressBookEntryMutationResult = Apollo.MutationResult<AddAddressBookEntryMutation>;
export type AddAddressBookEntryMutationOptions = Apollo.BaseMutationOptions<AddAddressBookEntryMutation, AddAddressBookEntryMutationVariables>;
export const UpdateAddressBookEntryDocument = gql`
    mutation UpdateAddressBookEntry($target: String!, $cn: String!, $entry: AddressBookEntryData!) {
  updateAddressBookEntry(target: $target, cn: $cn, entry: $entry) {
    errors {
      type
      location
      context
    }
  }
}
    `;
export type UpdateAddressBookEntryMutationFn = Apollo.MutationFunction<UpdateAddressBookEntryMutation, UpdateAddressBookEntryMutationVariables>;

/**
 * __useUpdateAddressBookEntryMutation__
 *
 * To run a mutation, you first call `useUpdateAddressBookEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressBookEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressBookEntryMutation, { data, loading, error }] = useUpdateAddressBookEntryMutation({
 *   variables: {
 *      target: // value for 'target'
 *      cn: // value for 'cn'
 *      entry: // value for 'entry'
 *   },
 * });
 */
export function useUpdateAddressBookEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressBookEntryMutation, UpdateAddressBookEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressBookEntryMutation, UpdateAddressBookEntryMutationVariables>(UpdateAddressBookEntryDocument, options);
      }
export type UpdateAddressBookEntryMutationHookResult = ReturnType<typeof useUpdateAddressBookEntryMutation>;
export type UpdateAddressBookEntryMutationResult = Apollo.MutationResult<UpdateAddressBookEntryMutation>;
export type UpdateAddressBookEntryMutationOptions = Apollo.BaseMutationOptions<UpdateAddressBookEntryMutation, UpdateAddressBookEntryMutationVariables>;
export const DeleteAddressBookEntryDocument = gql`
    mutation DeleteAddressBookEntry($target: String!, $cn: String!) {
  deleteAddressBookEntry(target: $target, cn: $cn) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type DeleteAddressBookEntryMutationFn = Apollo.MutationFunction<DeleteAddressBookEntryMutation, DeleteAddressBookEntryMutationVariables>;

/**
 * __useDeleteAddressBookEntryMutation__
 *
 * To run a mutation, you first call `useDeleteAddressBookEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressBookEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressBookEntryMutation, { data, loading, error }] = useDeleteAddressBookEntryMutation({
 *   variables: {
 *      target: // value for 'target'
 *      cn: // value for 'cn'
 *   },
 * });
 */
export function useDeleteAddressBookEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAddressBookEntryMutation, DeleteAddressBookEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAddressBookEntryMutation, DeleteAddressBookEntryMutationVariables>(DeleteAddressBookEntryDocument, options);
      }
export type DeleteAddressBookEntryMutationHookResult = ReturnType<typeof useDeleteAddressBookEntryMutation>;
export type DeleteAddressBookEntryMutationResult = Apollo.MutationResult<DeleteAddressBookEntryMutation>;
export type DeleteAddressBookEntryMutationOptions = Apollo.BaseMutationOptions<DeleteAddressBookEntryMutation, DeleteAddressBookEntryMutationVariables>;
export const PersonalTargetDocument = gql`
    query PersonalTarget($extensionId: Int!) {
  users(id: $extensionId) {
    items {
      number {
        shortNumber
        domain {
          name
        }
      }
    }
  }
}
    `;

/**
 * __usePersonalTargetQuery__
 *
 * To run a query within a React component, call `usePersonalTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalTargetQuery({
 *   variables: {
 *      extensionId: // value for 'extensionId'
 *   },
 * });
 */
export function usePersonalTargetQuery(baseOptions: Apollo.QueryHookOptions<PersonalTargetQuery, PersonalTargetQueryVariables> & ({ variables: PersonalTargetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalTargetQuery, PersonalTargetQueryVariables>(PersonalTargetDocument, options);
      }
export function usePersonalTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalTargetQuery, PersonalTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalTargetQuery, PersonalTargetQueryVariables>(PersonalTargetDocument, options);
        }
export function usePersonalTargetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalTargetQuery, PersonalTargetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalTargetQuery, PersonalTargetQueryVariables>(PersonalTargetDocument, options);
        }
export type PersonalTargetQueryHookResult = ReturnType<typeof usePersonalTargetQuery>;
export type PersonalTargetLazyQueryHookResult = ReturnType<typeof usePersonalTargetLazyQuery>;
export type PersonalTargetSuspenseQueryHookResult = ReturnType<typeof usePersonalTargetSuspenseQuery>;
export type PersonalTargetQueryResult = Apollo.QueryResult<PersonalTargetQuery, PersonalTargetQueryVariables>;
export const SynchronizeAddressBookDocument = gql`
    mutation SynchronizeAddressBook($domainId: Int!) {
  synchronizeDomainAddressBook(domainId: $domainId) {
    createdEntries
    updatedEntries
    deletedEntries
    failedEntries
  }
}
    `;
export type SynchronizeAddressBookMutationFn = Apollo.MutationFunction<SynchronizeAddressBookMutation, SynchronizeAddressBookMutationVariables>;

/**
 * __useSynchronizeAddressBookMutation__
 *
 * To run a mutation, you first call `useSynchronizeAddressBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSynchronizeAddressBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [synchronizeAddressBookMutation, { data, loading, error }] = useSynchronizeAddressBookMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useSynchronizeAddressBookMutation(baseOptions?: Apollo.MutationHookOptions<SynchronizeAddressBookMutation, SynchronizeAddressBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SynchronizeAddressBookMutation, SynchronizeAddressBookMutationVariables>(SynchronizeAddressBookDocument, options);
      }
export type SynchronizeAddressBookMutationHookResult = ReturnType<typeof useSynchronizeAddressBookMutation>;
export type SynchronizeAddressBookMutationResult = Apollo.MutationResult<SynchronizeAddressBookMutation>;
export type SynchronizeAddressBookMutationOptions = Apollo.BaseMutationOptions<SynchronizeAddressBookMutation, SynchronizeAddressBookMutationVariables>;